/** Shared generation-node UI labels (image / video / action shells). */
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export function useCanvasGenerationI18n() {
  const { t } = useTranslation('canvas')

  return useMemo(
    () => ({
      t,
      qualityOptions: [
        { value: 'STANDARD', label: t('generation.qualityStandard') },
        { value: 'HIGH', label: t('generation.qualityHigh') },
      ],
      imageCountOptions: [1, 2, 4].map((n) => ({
        value: n,
        label: t('generation.countUnit', { count: n }),
      })),
      videoQualityOptions: [
        { value: '1080P', label: t('generation.videoQuality1080') },
        { value: '720P', label: t('generation.videoQuality720') },
        { value: 'Normal', label: t('generation.videoQualityNormal') },
      ],
      statusLabel: (status: string) => {
        const map: Record<string, string> = {
          READY: t('generation.statusReady'),
          SUBMITTING: t('generation.statusSubmitting'),
          QUEUED: t('generation.statusQueued'),
          WAITING_FOR_ENGINE: t('generation.statusWaitingEngine'),
          UPLOADING_ASSETS: t('generation.statusUploadingAssets'),
          SUBMITTING_REQUEST: t('generation.statusSubmittingRequest'),
          RETRYING: t('generation.statusRetrying'),
          GENERATING: t('generation.statusGenerating'),
          COMPLETED: t('generation.statusCompleted'),
          FAILED: t('generation.statusFailed'),
        }
        return map[status] ?? status
      },
      mediaHeader: {
        collapse: t('generateAudio.header.collapse'),
        expand: t('generateAudio.header.expand'),
        download: t('generateAudio.header.download'),
        duplicate: t('generateAudio.header.duplicate'),
        delete: t('generateAudio.header.delete'),
        collapseAria: t('actions.close'),
        expandAria: t('generateAudio.header.expand'),
      },
      regenerate: {
        title: t('generation.regenerateTitle'),
        separate: t('generateAudio.regenerate.separate'),
        overwrite: t('generateAudio.regenerate.overwrite'),
      },
    }),
    [t],
  )
}
